import { Component, inject } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    standalone: false,
    selector: 'app-report-preview-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body p-0">
            <iframe [src]="url" class="report-preview-frame" [title]="title"></iframe>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="modalRef.hide()">Close</button>
        </div>
    `,
    styles: [
        `
            .report-preview-frame {
                width: 100%;
                height: 80vh;
                border: none;
            }
        `,
    ],
})
export class ReportPreviewDialogComponent {
    modalRef = inject(BsModalRef);

    title: string;
    url: SafeResourceUrl;
}
